import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  AfterViewInit,
} from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { EnvConfigurationService } from 'src/app/service/env-config.service';

@Component({
  selector: 'app-sensorstation-sumo-dashboard',
  templateUrl: './sensorstation-sumo-dashboard.component.html',
  styleUrl: './sensorstation-sumo-dashboard.component.scss',
  standalone: false,
})
export class SensorstationSumoDashboardComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  public url: SafeResourceUrl;

  private resizeListener: () => void;

  constructor(
    public envService: EnvConfigurationService,
    private elementRef: ElementRef,
    private sanitizer: DomSanitizer
  ) {
    const currentTime = new Date();
    const calcedMinutes =
      currentTime.getMinutes() % 5 < 2
        ? currentTime.getMinutes() - 2
        : currentTime.getMinutes();
    let minutes = calcedMinutes - ((calcedMinutes - 5) % 5);
    let hours = currentTime.getHours();
    if (calcedMinutes - 5 <= 0) {
      minutes = 55;
      hours = currentTime.getHours() - 1;
    }
    const referenceTime = new Date(
      currentTime.getFullYear(),
      currentTime.getMonth(),
      currentTime.getDate(),
      hours,
      minutes,
      0,
      0
    );
    const from = referenceTime.getTime();
    const to = from + 3600000;
    const emission = 'CO2'; // default

    this.updateIframes(from, to, emission);
  }

  private updateIframes(from: number, to: number, emission: string): void {
    const base = this.envService.config.sensorstationSUMO;
    this.url = this.sanitizer.bypassSecurityTrustResourceUrl(
      `${base}&from=${from}&to=${to}&emission=${emission}`
    );
  }

  ngOnInit(): void {
    this.setIframeHeights();
    this.resizeListener = this.updateIframeHeights.bind(this);
    window.addEventListener('resize', this.resizeListener);
  }

  ngAfterViewInit(): void {
    window.addEventListener('message', (event) => {
      if (
        event.data &&
        typeof event.data === 'object' &&
        'from' in event.data &&
        'to' in event.data &&
        'emission' in event.data
      ) {
        this.updateIframes(event.data.from, event.data.to, event.data.emission);
      }
    });
  }

  private setIframeHeights(): void {
    this.updateIframeHeights();
  }

  private updateIframeHeights(): void {
    const iframe = this.elementRef.nativeElement.querySelector(
      '#sensorstation-sumo'
    ) as HTMLIFrameElement;

    if (!iframe) {
      return;
    }

    const viewportHeight =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight;

    // Calculate how far the iframe is from the top of the viewport
    const topOffset = iframe.getBoundingClientRect().top;

    // Stretch the iframe so its bottom touches the bottom of the viewport
    iframe.style.height = `${viewportHeight - topOffset - 69}px`;
  }

  ngOnDestroy(): void {
    if (this.resizeListener) {
      window.removeEventListener('resize', this.resizeListener);
    }
  }
}
